<template>
  <main class="matriculas-v2-handoff">
    <section>
      <div class="loader" />
      <h1>Abrindo Matrículas V2</h1>
      <p>{{ message }}</p>
      <button v-if="error" type="button" @click="retry">
        Tentar novamente
      </button>
    </section>
  </main>
</template>

<script>
import MatriculasV2Service from '@/services/matriculas-v2.service'

export default {
  name: 'MatriculasV2Handoff',
  data () {
    return {
      error: null,
      message: 'Validando seu acesso no Apollo...'
    }
  },
  mounted () {
    this.openMatriculasV2()
  },
  methods: {
    retry () {
      this.error = null
      this.message = 'Validando seu acesso no Apollo...'
      this.openMatriculasV2()
    },
    async openMatriculasV2 () {
      try {
        const response = await MatriculasV2Service.handoff({
          redirectTo: this.redirectTo(),
          embedded: this.$route.query.embed === '1' || this.$route.query.embed === 'apollo'
        })

        this.message = 'Redirecionando...'
        window.location.href = response.data.redirect_url
      } catch (error) {
        this.error = error
        this.message = error.response?.data?.message || error.message || 'Não foi possível abrir o Matrículas V2.'
      }
    },
    redirectTo () {
      if (this.$route.query.redirect) {
        return this.$route.query.redirect
      }

      const screen = this.$route.params.screen || 'pesquisa'
      const idMatricula = this.$route.params.idMatricula

      if (screen === 'financeiro' && idMatricula) {
        return `/matriculas/${idMatricula}/financeiro`
      }

      if (screen === 'nova') {
        return '/matriculas/nova'
      }

      if (screen === 'lista') {
        return '/matriculas/lista-matriculas'
      }

      if (screen === 'documentos') {
        return '/matriculas/documentos'
      }

      if (screen === 'editar' && idMatricula) {
        return `/matricula/editar/matricula/${idMatricula}`
      }

      return '/matriculas/pesquisa'
    }
  }
}
</script>

<style scoped>
.matriculas-v2-handoff {
  align-items: center;
  background: #f4f5f8;
  color: #5f6977;
  display: flex;
  min-height: 100vh;
  justify-content: center;
  padding: 32px;
}

.matriculas-v2-handoff section {
  align-items: center;
  background: #fff;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  max-width: 420px;
  padding: 32px;
  text-align: center;
  width: 100%;
}

.matriculas-v2-handoff h1 {
  color: #3e4652;
  font-size: 20px;
  font-weight: 800;
  margin: 18px 0 8px;
}

.matriculas-v2-handoff p {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0;
}

.matriculas-v2-handoff button {
  background: #ff0032;
  border: 0;
  border-radius: 999px;
  color: #fff;
  cursor: pointer;
  font-size: 13px;
  font-weight: 800;
  margin-top: 20px;
  min-height: 38px;
  padding: 0 18px;
}

.loader {
  animation: spin 0.8s linear infinite;
  border: 3px solid #f0b4bf;
  border-top-color: #ff0032;
  border-radius: 50%;
  height: 38px;
  width: 38px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
